import React from 'react';
import { AboutAs } from '../AboutAs/AboutAs';

export const HomePage = ({
  sliderImages,
  paddingCalc,
}: {
  sliderImages: string[];
  paddingCalc: { paddingTop: number };
}) => {
  return (
    <>
      <AboutAs sliderImages={sliderImages} paddingStyle={paddingCalc} />
    </>
  );
};
